import { makeStyles } from '@mui/styles';
import { greys, mainColors } from '../../../../../styling/theme';

export const useRaidrViewStyles = makeStyles(() => ({
  parentContainer: {
    minHeight: '12.50rem',
    display: 'flex',
    flexDirection: 'column',
    margin: '1.25rem',
    gap: '1.25rem',
    width: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    gap: '0.62rem',
    flexDirection: 'column',
  },
  button: {
    height: '1.88rem',
    marginRight: '0.62rem',
    width: '6.25rem',
  },
  viewerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '0.62rem',
  },
  iframeContainer: {
    border: '2px solid',
    borderColor: mainColors.mainBlue,
    width: '100%',
    height: '85vh',
    display: 'flex',
    justifyContent: 'space-around',
    backgroundColor: 'white',
  },
  arrow: {
    '&:before': {
      border: '1px solid #8e8e8e',
    },
    color: greys.grey600,
  },
  tooltip: {
    backgroundColor: greys.grey600,
    border: '1px solid #8e8e8e',
    color: 'white',
  },
  fundNameContainer: {
    width: '100%',
    maxHeight: '1.88rem',
    marginRight: '0.62rem',
    marginLeft: '0.62rem',
    whiteSpace: 'nowrap',
  },
  versionNumberContainer: {
    width: '100%',
    maxHeight: '1.88rem',
    marginRight: '0.62rem',
    marginLeft: '0.62rem',
    whiteSpace: 'nowrap',
    backgroundColor: mainColors.mainBlue,
    borderRadius: '5px',
    color: 'white',
    boxSizing: 'border-box',
    paddingRight: '5px',
    paddingLeft: '5px',
    fontSize: '0.75rem',
    display: 'flex',
    fontWeight: 600,
  },
}));
